import { render } from "./BigImg.vue?vue&type=template&id=4b7ed5fa&scoped=true"
import script from "./BigImg.vue?vue&type=script&lang=js"
export * from "./BigImg.vue?vue&type=script&lang=js"

import "./BigImg.vue?vue&type=style&index=0&id=4b7ed5fa&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7ed5fa"]])

export default __exports__